import { jsx as _jsx } from "react/jsx-runtime";
import icon from './plus.svg';
// eslint-disable-next-line
export const PlusSvgComponent = () => (_jsx("svg", { viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M19.5 13H13.5V19H11.5V13H5.5V11H11.5V5H13.5V11H19.5V13Z' }) }));
export default icon;
